export default __webpack_public_path__ + "static/media/slider04.fe7f8f16.png";